export default "<p>recipt-from-rivhit works!</p>\n"